import React, { Fragment } from "react";
import "./redoc-tryout.css";
import MoveBox from "../moveBox/MoveBox";
import TryOutForm from "./redocTryOutForm/redocTryOutForm";
import FaSpinner from "../faSpinner/faSpinner";
import RedocTryoutInfo from "./redocTryOutForm/redocTryoutTopInfo";
import Button from "../button/button";
import { bemClassesFromModifiers } from "../../constants/misc";
import PinIcon from "../svgs/pinIcon";
import OrientationToggleIcon from "../svgs/orientationToggleIcon";
import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";
import {
  getTryoutSettings,
  saveTryoutOrientation,
} from "../../utils/tryoutStorage";

class TryItOut extends React.Component {
  componentDidMount() {
    // Load saved orientation setting
    const savedSettings = getTryoutSettings();
    if (
      savedSettings.horLayout !== undefined &&
      this.props.horLayout === undefined
    ) {
      this.update({ horLayout: savedSettings.horLayout });
    }
  }

  update = (values) => {
    const { method, path } = this.props;
    this.props.updateTryout(path, method, values);
  };

  handleParameterChange = (evt, param) => {
    this.update({
      form: {
        ...this.props.form,
        [param.in]: {
          ...this.props.form[param.in],
          [param.name]: evt.target.value,
        },
      },
    });
  };

  applyToken = (token, tokenType) => {
    this.update({
      form: {
        ...this.props.form,
        ["header"]: {
          ...this.props.form["header"],
          ["Authorization"]: tokenType + " " + token,
        },
      },
    });
  };

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.update({
      form: {
        ...this.props.form,
        [name]: value,
      },
    });
  };

  submitForm = (evt) => {
    evt.preventDefault();
    const { form, sendRequest } = this.props;
    sendRequest(form);
  };

  _minifyForm = (minified) => {
    this.update({
      minified: minified,
    });
  };

  _closeForm = () => {
    const { tryoutsHide } = this.props;
    this.update({
      formShown: false,
      response: null,
    });
    if (tryoutsHide) {
      tryoutsHide();
    }
  };

  toggleLayout = () => {
    const { horLayout } = this.props;
    const newHorLayout = !horLayout;

    this.update({
      horLayout: newHorLayout,
    });

    // Save orientation preference
    saveTryoutOrientation(newHorLayout);
  };

  render() {
    const {
      edit,
      cancelRequest,
      title,
      pinned,
      horLayout,
      pinTryOut,
      method,
      parameters,
      path,
      formShown,
      formErrors,
      loading,
      security,
      form,
      children,
      dockDirection,
      actions,
      expandIcon,
      documentationId,
      applications,
      minified,
    } = this.props;

    console.log("[TRYOUT DEBUG] TryItOut component render:", {
      path,
      method,
      formShown,
      minified,
      hasForm: !!form,
      hasParameters: !!parameters,
      parameterCount: parameters?.length || 0,
    });

    return (
      <div>
        {formShown ? (
          <MoveBox
            fullscreenMobile={window.innerWidth <= 900}
            isTryoutWindow={true}
            dockDirection={dockDirection}
            minified={minified}
            className={bemClassesFromModifiers("tryout-form", [
              form.body && horLayout ? "horizontal" : null,
              edit ? "edit" : null,
            ])}
            expandIcon={expandIcon}
            title={title ? title : "Try Out"}
            titleAction={
              <Fragment>
                {(parameters && parameters.length > 0) || form.body ? (
                  <span
                    title={
                      horLayout
                        ? "Switch to Vertical Layout"
                        : "Switch to Horizontal Layout"
                    }
                    className="tryout-form__orientation"
                    onClick={this.toggleLayout}
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    <OrientationToggleIcon isHorizontal={horLayout} />
                  </span>
                ) : null}
                {pinTryOut ? (
                  <Button
                    onClick={pinTryOut}
                    title="Scrolling will not automatically change tryout"
                    className={bemClassesFromModifiers("tryout-form__pin", [
                      pinned ? "pinned" : null,
                    ])}
                  >
                    <PinIcon />
                  </Button>
                ) : null}
              </Fragment>
            }
            onMinify={this._minifyForm}
            onClose={this._closeForm}
            actions={
              <Fragment>
                <FaSpinner
                  mini
                  loading={loading}
                  style={
                    loading
                      ? {
                          marginLeft: 0,
                          marginRight: 8,
                        }
                      : {}
                  }
                />

                {loading && cancelRequest && (
                  <SimpleButtonWrapper
                    position="right"
                    style={{ marginLeft: "auto" }}
                  >
                    <Button
                      className="electro cancel-request"
                      onClick={cancelRequest}
                    >
                      Cancel
                    </Button>
                  </SimpleButtonWrapper>
                )}
                {actions}
              </Fragment>
            }
          >
            <RedocTryoutInfo
              method={method}
              path={path}
              onSubmit={this.submitForm}
              loading={loading}
            />
            {children}
            <div className="tryout-form__content">
              <TryOutForm
                security={security}
                form={form}
                handleParameterChange={this.handleParameterChange}
                method={method}
                path={path}
                parameters={parameters}
                parameterErrors={formErrors}
                handleInputChange={this.handleInputChange}
                documentationId={documentationId}
                applications={applications}
                productUuid={this.props.productUuid}
                applyToken={this.applyToken}
                swaggerJson={this.props.swaggerJson}
                horLayout={horLayout}
              />
            </div>
          </MoveBox>
        ) : null}
      </div>
    );
  }
}

export default TryItOut;
